/* Healthy Emmie landing page behaviour (templates/page.healthy-emmie-landing.json).
   Loaded with defer from every he- section; the guard below makes it run once.
   Spec: docs/healthy-emmie/HEALTHY_EMMIE_SPEC.md (sections 4.6, 4.14, 6, 7). */
(function () {
  'use strict';

  var root = document.documentElement;
  if (root.hasAttribute('data-he-landing')) return;
  root.setAttribute('data-he-landing', '');

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var POPUP_KEY = 'he-ebook-popup-dismissed';
  var KLAVIYO_REVISION = '2024-10-15';
  var CAMPAIGN = 'Healthy Emmie';
  var DRAWER_TIMEOUT = 5000;

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function each(scope, selector, fn) {
    Array.prototype.forEach.call(scope.querySelectorAll(selector), fn);
  }

  // Marks an element as initialised so section re-renders in the editor don't bind twice.
  function bindOnce(el, key) {
    var attr = 'data-he-bound-' + key;
    if (el.hasAttribute(attr)) return false;
    el.setAttribute(attr, '');
    return true;
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    if (busy) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  }

  /* ---------- Add to Cart (spec 6) ---------- */

  // Approved exception to spec rule 0.2 point 5 (spec 11 #12). The header group is not rendered
  // on this template, so the theme never sets window.inertElems (used by the drawer's show/hide)
  // and never binds the overlay click. Only runs for forms rendered on this template.
  function prepareDrawer() {
    if (typeof window.inertElems === 'undefined') {
      each(document, '#main > .shopify-section', function (section) {
        if (section.querySelector('.he-page') && !section.querySelector('[data-he-popup]')) {
          section.setAttribute('data-js-inert', '');
        }
      });
      window.inertElems = document.querySelectorAll('[data-js-inert]');
    }
    var overlay = document.querySelector('.site-overlay');
    if (overlay && bindOnce(overlay, 'overlay')) {
      overlay.addEventListener('click', function () {
        var opened = document.querySelector('.sidebar--opened');
        if (opened && typeof opened.hide === 'function') opened.hide();
      });
    }
  }

  function openCart(form) {
    var cartUrl = form.getAttribute('data-cart-url') || '/cart';
    var drawer = document.querySelector('[data-js-site-cart-sidebar]');

    if (!drawer || typeof drawer.show !== 'function' || typeof window.refreshCart !== 'function') {
      window.location.href = cartUrl;
      return;
    }

    var opened = false;
    var observer = new MutationObserver(function () {
      if (drawer.classList.contains('sidebar--opened')) {
        opened = true;
        observer.disconnect();
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    try {
      if (form.hasAttribute('data-he-drawer-shim')) prepareDrawer();
      window.refreshCart();
    } catch (err) {
      observer.disconnect();
      window.location.href = cartUrl;
      return;
    }

    // Fallback (Option 2): the item is already in the cart, so go to the cart page if the drawer never opened.
    window.setTimeout(function () {
      observer.disconnect();
      if (!opened && !drawer.classList.contains('sidebar--opened')) window.location.href = cartUrl;
    }, DRAWER_TIMEOUT);
  }

  // "After Add to Cart" setting (spec 6). Runs only after /cart/add.js succeeded.
  function afterAdd(form) {
    var action = form.getAttribute('data-after-add');
    if (action === 'cart') {
      window.location.href = form.getAttribute('data-cart-url') || '/cart';
    } else if (action === 'checkout') {
      window.location.href = form.getAttribute('data-checkout-url') || '/checkout';
    } else {
      openCart(form);
    }
  }

  function initAtc(scope) {
    each(scope, 'form[data-he-atc]', function (form) {
      if (!bindOnce(form, 'atc')) return;

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('[type="submit"]');
        var errorEl = form.querySelector('.he-atc__error');
        if (!button || button.disabled) return;

        setBusy(button, true);
        if (errorEl) errorEl.textContent = '';

        fetch((form.getAttribute('action') || '/cart/add') + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok || data.status) {
                var error = new Error('cart-add');
                error.heMessage = data.description || data.message || '';
                throw error;
              }
              return data;
            });
          })
          .then(function () {
            afterAdd(form);
          })
          .catch(function (error) {
            if (errorEl) errorEl.textContent = (error && error.heMessage) || form.getAttribute('data-error') || '';
          })
          .then(function () {
            setBusy(button, false);
          });
      });
    });
  }

  /* ---------- GIF / video: play only while in view (spec 4.6) ---------- */

  function play(video) {
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(function () {});
  }

  function initVideos(scope) {
    var videos = [];
    each(scope, 'video[data-he-video]', function (video) {
      if (bindOnce(video, 'video')) videos.push(video);
    });
    if (!videos.length) return;

    if (reducedMotion()) {
      videos.forEach(function (video) {
        video.removeAttribute('autoplay');
        video.pause();
        video.controls = true;
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(play);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.target.offsetParent !== null) {
          play(entry.target);
        } else {
          entry.target.pause();
        }
      });
    }, { rootMargin: '200px 0px' });

    videos.forEach(function (video) {
      if (video.offsetParent === null) video.pause();
      observer.observe(video);
    });
  }

  /* ---------- Klaviyo sign-up (spec 7) ---------- */

  function subscribe(form, fields) {
    var key = form.getAttribute('data-key');
    var list = form.getAttribute('data-list');
    if (!key || !list) {
      if (isDesignMode()) console.warn('[he-landing] Klaviyo public key or list ID is empty, sign-up was not sent.');
      return Promise.reject(new Error('klaviyo-config'));
    }

    var source = form.getAttribute('data-source') || '';
    var properties = { signup_source: source, campaign: CAMPAIGN };
    if (fields.skin_concern) properties.skin_concern = fields.skin_concern;
    if (fields.age_range) properties.age_range = fields.age_range;

    var profile = {
      email: fields.email,
      properties: properties,
    };
    if (fields.first_name) profile.first_name = fields.first_name;

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: profile } }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('klaviyo-' + response.status);
    });
  }

  function fieldValue(form, name) {
    var field = form.elements[name];
    return field && field.value ? field.value.trim() : '';
  }

  function initSignupForms(scope) {
    each(scope, 'form[data-he-signup]', function (form) {
      if (!bindOnce(form, 'signup')) return;

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var msg = form.querySelector('.he-form-msg');
        var button = form.querySelector('[type="submit"]');
        var emailInput = form.elements.email;
        var email = fieldValue(form, 'email');

        function setMsg(text) {
          if (msg) msg.textContent = text || '';
        }

        setMsg('');
        if (!EMAIL_RE.test(email)) {
          setMsg(form.getAttribute('data-invalid'));
          if (emailInput) {
            emailInput.setAttribute('aria-invalid', 'true');
            emailInput.focus();
          }
          return;
        }
        if (emailInput) emailInput.removeAttribute('aria-invalid');

        setBusy(button, true);
        subscribe(form, {
          email: email,
          first_name: fieldValue(form, 'first_name'),
          skin_concern: fieldValue(form, 'skin_concern'),
          age_range: fieldValue(form, 'age_range')
        })
          .then(function () {
            form.reset();
            if (form.getAttribute('data-he-signup') === 'popup') {
              var popup = form.closest('[data-he-popup]');
              if (popup) popup.dispatchEvent(new CustomEvent('he:close'));
            } else {
              setMsg(form.getAttribute('data-success'));
            }
          })
          .catch(function () {
            setMsg(form.getAttribute('data-error'));
          })
          .then(function () {
            setBusy(button, false);
          });
      });
    });
  }

  /* ---------- E-book popup (spec 4.14) ---------- */

  function wasDismissed() {
    try {
      return window.sessionStorage.getItem(POPUP_KEY) === '1';
    } catch (err) {
      return false;
    }
  }

  function rememberDismissed() {
    try {
      window.sessionStorage.setItem(POPUP_KEY, '1');
    } catch (err) {
      /* storage unavailable: popup may show again */
    }
  }

  function initPopups(scope) {
    each(scope, '[data-he-popup]', function (popup) {
      if (!bindOnce(popup, 'popup')) return;
      var lastFocus = null;

      function focusables() {
        return Array.prototype.filter.call(
          popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
          function (el) { return !el.disabled && el.offsetParent !== null; }
        );
      }

      function onKeydown(event) {
        if (event.key === 'Escape') {
          close(true);
        } else if (event.key === 'Tab') {
          var items = focusables();
          if (!items.length) return;
          var first = items[0];
          var last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }

      function open() {
        if (popup.classList.contains('is-open')) return;
        lastFocus = document.activeElement;
        popup.classList.add('is-open');
        document.addEventListener('keydown', onKeydown);
        var target = popup.querySelector('input') || popup.querySelector('button');
        if (target) target.focus();
      }

      function close(remember) {
        if (!popup.classList.contains('is-open')) return;
        popup.classList.remove('is-open');
        document.removeEventListener('keydown', onKeydown);
        if (remember && !isDesignMode()) rememberDismissed();
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        lastFocus = null;
      }

      popup.addEventListener('click', function (event) {
        if (event.target === popup) close(true);
      });
      each(popup, '[data-he-popup-close]', function (button) {
        button.addEventListener('click', function () {
          close(true);
        });
      });
      popup.addEventListener('he:open', open);
      popup.addEventListener('he:close', function () {
        close(true);
      });

      if (isDesignMode() || popup.getAttribute('data-enabled') !== 'true' || wasDismissed()) return;

      var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 0) * 1000;
      var start = function () {
        window.setTimeout(function () {
          if (!wasDismissed()) open();
        }, delay);
      };
      if (document.readyState === 'complete') {
        start();
      } else {
        window.addEventListener('load', start, { once: true });
      }
    });
  }

  /* ---------- Focus outline for keyboard users only (forms + popup, see CSS) ---------- */

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') document.documentElement.classList.add('he-kbd');
  }, true);
  document.addEventListener('pointerdown', function () {
    document.documentElement.classList.remove('he-kbd');
  }, true);

  /* ---------- Smooth scroll for in-page anchors (e.g. hero "Read reviews") ---------- */

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('.he-page a[href^="#"]') : null;
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
    var id = link.getAttribute('href').slice(1);
    var target = null;
    try { target = id && document.getElementById(decodeURIComponent(id)); } catch (e) { return; }
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    if (window.history && history.pushState) history.pushState(null, '', '#' + id);
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });

  /* ---------- Init + theme editor events ---------- */

  function init(scope) {
    initAtc(scope);
    initVideos(scope);
    initSignupForms(scope);
    initPopups(scope);
  }

  function sectionPopup(event) {
    return event.target && event.target.querySelector ? event.target.querySelector('[data-he-popup]') : null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    var popup = sectionPopup(event);
    if (popup) popup.dispatchEvent(new CustomEvent('he:open'));
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    var popup = sectionPopup(event);
    if (popup) popup.dispatchEvent(new CustomEvent('he:close'));
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var popup = sectionPopup(event);
    if (popup) popup.dispatchEvent(new CustomEvent('he:close'));
  });
})();
